import React, { Component } from 'react';
import CalendarNavBigScreen from '../../../containers/CalendarNavBigScreen';
import CalendarNavSmallScreen from '../../../containers/CalendarNavSmallScreen';
import type { NavProps } from '../../../types';

const dummyFunc = () => { };

class NavContent extends Component<NavProps> {
  static defaultProps = {
    isCalendar: false,
    navDates: {},
    onNavNextWeekClick: dummyFunc,
    onNavPrevWeekClick: dummyFunc,
    isYearCalendar: false,
    selectedYear: 0,
    onNavPrevYearClick: dummyFunc,
    onNavNextYearClick: dummyFunc,
    onNavYearCalendarClick: dummyFunc,
    onToggleStatistics: dummyFunc,
    onPayrollGeneratorClick: dummyFunc,
    onMarketingStatsClick: dummyFunc,
  };

  render(): React.ReactNode {
    return (
      <>
        <CalendarNavBigScreen {...this.props} />
        <CalendarNavSmallScreen {...this.props} />
      </>
    );
  }
}

export default NavContent;
